<template>
  <div class="imagelist">
    <div class="image-card" v-for="(image, index) of imageList" :key="image.id">
      <div class="image-content">
        <img :src="imageReformat(image.url)" @click="toImageDetail(image.id, getImageId(image.id, index))" />
      </div>
      <div class="image-info">
        <span id="imageid">{{ getImageId(image.id, index) }}</span>
        <button class="delete-button" @click="deleteImage(image.id)">删除</button>
        <span id="imagestatus">{{ imageStatusMap[image.status] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import { imageStatusMap } from '@/config';
import { imageReformat } from '@/utils/util';

export default {
  name: 'imagelist',
  data() {
    return {
      imageStatusMap: [],
    };
  },
  props: ['imageList', 'taskId', 'pageIndex', 'pageSize', 'imageStatus'],
  mounted: function() {
    this.imageStatusMap = imageStatusMap;
  },
  methods: {
    deleteImage(imageId) {
      if (!window.confirm(`确认删除ID为${imageId}的图片吗？`)) return;
      api
        .deleteImage({ taskId: this.taskId, imageId })
        .then(() => {
          this.$emit('getImageList');
        })
        .catch(() => {});
    },
    getImageId(imageId, index) {
      if (this.$store.state.role === 'admin') return imageId;
      return this.pageIndex * this.pageSize + index + 1;
    },
    toImageDetail(imageId, orderNumber) {
      if (this.$store.state.role === 'customer') {
        this.$router.push({
          path: `/task/` + this.taskId + `/image/` + imageId,
          query: { f: 'd', tid: this.taskId, orderNumber: orderNumber },
        });
      } else if (this.$store.state.role === 'admin') {
        this.$store.commit('setAdminImageList', {
          imageList: this.imageList.map(v => {
            return {
              imageId: v.id,
              taskId: this.taskId,
            };
          }),
        });
        this.$router.push({
          path: `/image/` + imageId,
          query: { f: 'd', tid: this.taskId, page: this.pageIndex, pagesize: this.pageSize, status: this.imageStatus },
          // query: { f: 'd', tid: this.taskId, page: this.pageIndex, status: this.imageStatus },
        });
      }
    },
    imageReformat,
  },
};
</script>

<style scoped>
.imagelist {
  text-align: left;
}
.image-card {
  display: inline-block;
  margin: 0px;
  margin-bottom: 12px;
  padding: 0px;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  vertical-align: top;
  width: 245px;
}
.delete-button {
  display: none;
  background: #c05d5d;
  margin-top: 4px;
}
.image-card:hover .delete-button {
  display: inline-block;
}
.image-info {
  height: 36px;
  position: relative;
}
.image-content {
  height: 150px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
}
p {
  margin: 10px;
}
img {
  max-height: 150px;
  max-width: 243px;
  cursor: pointer;
  margin: auto;
}
#imageid {
  bottom: 10px;
  left: 12px;
  position: absolute;
  font-size: 14px;
}
#imagestatus {
  position: absolute;
  bottom: 10px;
  right: 12px;
  font-size: 14px;
}
</style>
